<template>
  <div class="videoPage">
    <!-- <h4>东华停车场</h4>
    <p class="fgx"><van-divider dashed></van-divider></p>   -->
    <div class="videoBox">
      <LivePlayer
        :videoUrl="vUrl"
        autoplay
        live
        stretch
        class="mb10 mySelfVideo"
      ></LivePlayer>
      <!-- <iframe src='http://192.168.30.105:5000/webapi/entry.cgi?api=SYNO.SurveillanceStation.Recording.ShareRecording&version=1&method=Play&evtHash=vYpXM1UrB' allowfullscreen='true'></iframe> -->
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
import LivePlayer from "@liveqing/liveplayer";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "videoPage",
  components: { LivePlayer },
  data() {
    return {
      vUrl: "",
    };
  },

  mounted() {
    this.clientType = getDeviceType();
    this.setShowLoad(false); //加载状态，默认为true加载
    this.getVideoUrl();
  },
  methods: {
    ...mapMutations(["setShowLoad", "setAppData"]),
    getVideoUrl() {
      let _this = this;
      _this.$api.userCenter.user
        .getVideoUrl({
          isHTTPS:true,
          type:_this.clientType == 'android' ? 'flv' : 'm3u8'
        })
        .then((res) => {
          if (res.code == "1") {
            _this.vUrl = res.data;
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.videoPage {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #f6f6f6;

  > h4 {
    padding-top: 10px;
    text-align: center;
    line-height: 30px;
    color: #333;
    font-size: 20px;
  }
  .fgx{
    width: 100%;
    padding: 0 16px;
  }
  .van-divider{
    color: #333;
    border-color: #333;
  }
  .videoBox {
    width: 100%;
    height: 100%;
     position: absolute;
     left: 0;
     top: 30%;
    .mySelfVideo {
      width: 100%;
      height: 40%;
      position: relative;
      .video-wrapper {
        height: 100%;
        padding-bottom: 10% !important;
      }
      .vjs-big-play-button {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
}
</style>